import { useContext } from "react"

import { RecentReadingsContext } from "./RecentReadingsContext"

export function useRecentReadings() {
  const recentReadings = useContext(RecentReadingsContext)

  if (recentReadings === null) {
    throw new Error("recentReadings context is not defined")
  }

  return recentReadings
}

